import React from 'react';
import { DateInput } from 'semantic-ui-calendar-react';
import 'moment/locale/pt-br';

class CustomDatePicker extends React.Component {
    constructor(props) {
        super(props)

        this.state = { width: window.innerWidth }
    }

    _onResize = () => {
        this.setState({
            width: window.innerWidth
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this._onResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._onResize)
    }

    render() {

        const { onChangeDate, selectedDate, placeholder, name } = this.props;
        const { width } = this.state;

        return (width > 720 ?
            <DateInput
                localization='pt-br'
                name={name}
                closeOnMouseLeave={true}
                placeholder={placeholder}
                value={selectedDate.replace(/(\d{4})-?(\d{2})-?(\d{2})/, '$3/$2/$1')}
                dateFormat="DD/MM/YYYY"
                onChange={(_, { value }) =>
                    onChangeDate(
                        value.replace(/(\d{2})\/?(\d{2})\/?(\d{4})/, '$3-$2-$1'))} />
            :
            <input type='date'
                value={selectedDate}
                onChange={(event) => onChangeDate(event.target.value)}
            />);
    }
}

export default CustomDatePicker;